// extracted by mini-css-extract-plugin
module.exports = {"img":"PasteModal_img__lKIPG"};